module.exports = __webpack_public_path__ + "img/centrum-cocktailkaart.dbede5e1.png";